// @ts-ignore
import nprogress from 'nprogress'

export interface ProgressOptions {
  minimum?: number
  easing?: string
  speed?: number
  trickle?: boolean
  trickleRate?: number
  trickleSpeed?: number
  parent?: string
  positionUsing?: string
  barSelector?: string
  spinnerSelector?: string
}

/**
 * 封装 nprogress 的自定义 Hooks
 *
 * @param options - Nprogress 的配置选项
 * @returns 包含 start、done、update 和 cleanup 方法的对象
 */
export const useProgress = (options?: ProgressOptions) => {
  // 初始化 nprogress
  const config = {
    ...(options || {}),
    showSpinner: false,
    template: '<div class="bar" role="bar"></div>',
  }
  nprogress.configure(config)

  /** 开始显示进度条 */
  const start = () => {
    if (nprogress.isStarted()) return
    nprogress.start()
  }

  const update = (progress: number) => {
    nprogress.set(progress)
  }

  /** 完成进度条并隐藏 */
  const done = () => {
    nprogress.done()
  }

  /** 清理进度条状态 */
  const cleanup = () => {
    nprogress.remove()
    nprogress.done()
  }

  return {
    start,
    update,
    done,
    cleanup,
  }
}
